import { useEffect, useState } from "react"
import { axios_cms, axios } from "../../helpers"
import useSlider from "../../dummies/sliders"
import usePpgSteps from "../../dummies/ppg_steps"
import useGallery from "../../dummies/gallery"
import useYoutube from "../../hooks/useYoutube"
import GLightbox from "glightbox"
import 'glightbox/dist/css/glightbox.css'

const useLandingPage = () => {
    const [numFaq, setNumFaq] = useState(0)
    const [data, setData] = useState([])
    const [dataFaq, setDataFaq] = useState([])
    const [dataVideo, setDataVideo] = useState([])
    const [dataInfografis, setDataInfografis] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadingFaq, setIsLoadingFaq] = useState(false)
    const [isLoadingVideo, setIsLoadingVideo] = useState(false)
    const [isLoadingInfografis, setIsLoadingInfografis] = useState(false)
    const [isShowRegButton, setIsShowRegButton] = useState(false)
    const [keyword, setKeyword] = useState("")

    const { sliders } = useSlider()
    const { ppgSteps, setPpgSteps } = usePpgSteps()
    const { data: dataGallery } = useGallery()
    const { getThumbnailImage } = useYoutube()

    useEffect(() => {
        const lightbox = GLightbox({ selector: '.glightbox' });
        return () => {
            lightbox.destroy();
        };
    }, [dataVideo, dataInfografis])
    

    const handleSelectFaq = (i) => {
        if (numFaq === i) {
            setNumFaq(null)
        } else {
            setNumFaq(i)
        }
    }

    const handleShowRegButton = () => {
        setIsShowRegButton(!isShowRegButton)
    }

    const handleShowFullStep = (i) => {
        const newPpgSteps = [...ppgSteps]
        newPpgSteps[i].isShow = !newPpgSteps[i].isShow
        setPpgSteps(newPpgSteps)
    }

    useEffect(() => {
        const delayDebouncer = setTimeout(() => {
            fetchDocument(1)
            fetchFaq()
            fetchVideo()
            fetchInfografis()
        }, 500)
        return () => clearTimeout(delayDebouncer)
    }, [keyword])

    const fetchInfografis = async () => {
        setIsLoadingInfografis(true)
        try {
            const response = await axios.get(`/galeri?kategori=2`)
            if (response.status === 200) {
                setDataInfografis(response.data.data.rows)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoadingInfografis(false)
        }
    }


    const fetchVideo = async () => {
        setIsLoadingVideo(true)
        try {
            const response = await axios.get(`/galeri?kategori=3`)
            if (response.status === 200) {
                setDataVideo(response.data.data.rows)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoadingVideo(false)
        }
    }

    const fetchFaq = async () => {
        setIsLoadingFaq(true)
        try {
            const response = await axios.get(`/faq`)
            if (response.status === 200) {
                setDataFaq(response.data.data)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoadingFaq(false)
        }
    }

    const fetchDocument = async (page) => {
        setIsLoading(true)
        try {

            const response = await axios_cms.get(`/posts/articles?tags=ppg&page=${page}&limit=4`)
            if (response.status === 200) {
                setData(response.data.data)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleMobileNavToggle = () => {
        const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle');
        document.querySelector('body').classList.toggle('mobile-nav-active');
        mobileNavToggleBtn.classList.toggle('bi-list');
        mobileNavToggleBtn.classList.toggle('bi-x');

        const newsToggle = document.querySelector(".news-toggle")
        const newsToggleList = document.querySelector(".news-toggle-list")
        newsToggle.classList.remove("active")
        newsToggleList.classList.remove("dropdown-active")

        const provisionToggle = document.querySelector(".provision-toggle")
        const provisionToggleList = document.querySelector(".provision-toggle-list")
        provisionToggle.classList.remove("active")
        provisionToggleList.classList.remove("dropdown-active")
    }

    const handleMobileSelectNavMenu = () => {
        if (document.querySelector('.mobile-nav-active')) {
            handleMobileNavToggle();
        }
    }

    const handleMobileToggleNavMenu = (e, classN) => {
        e.preventDefault()
        const mobileToggleNavMenu = document.querySelector(`.${classN}-toggle`)
        const mobileToggleNavMenuList = document.querySelector(`.${classN}-toggle-list`)
        mobileToggleNavMenu.classList.toggle('active')
        mobileToggleNavMenuList.classList.toggle('dropdown-active')
    }

    return {
        data,
        numFaq,
        dataFaq,
        sliders,
        ppgSteps,
        dataVideo,
        isLoading,
        dataGallery,
        isLoadingFaq,
        isLoadingVideo,
        dataInfografis,
        isShowRegButton,
        isLoadingInfografis,
        handleSelectFaq,
        getThumbnailImage,
        handleShowFullStep,
        handleShowRegButton,
        handleMobileNavToggle,
        handleMobileSelectNavMenu,
        handleMobileToggleNavMenu,
    }
}
export default useLandingPage